import { render, staticRenderFns } from "./FormContact.vue?vue&type=template&id=73402a2f"
import script from "./FormContact.vue?vue&type=script&lang=js"
export * from "./FormContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Input: require('/home/runner/work/platform/platform/packages/client/src/components/elements/form/input/Input.vue').default,Field: require('/home/runner/work/platform/platform/packages/client/src/components/elements/form/field/Field.vue').default,InputTelephone: require('/home/runner/work/platform/platform/packages/client/src/components/elements/form/input/templates/telephone/InputTelephone.vue').default,Select: require('/home/runner/work/platform/platform/packages/client/src/components/elements/form/select/Select.vue').default,Notification: require('/home/runner/work/platform/platform/packages/client/src/components/elements/base/notification/Notification.vue').default,TextArea: require('/home/runner/work/platform/platform/packages/client/src/components/elements/form/text-area/TextArea.vue').default,DevDebug: require('/home/runner/work/platform/platform/packages/client/src/components/utils/dev-debug/DevDebug.vue').default,Form: require('/home/runner/work/platform/platform/packages/client/src/components/elements/form/form/Form.vue').default})
